/* Claude 2026-10-18: kategori-/varumärkessidor (sections/main-collection.liquid) */
(function(){
  var page=document.querySelector('[data-cc-page]');
  if(!page)return;
  document.documentElement.classList.add('cc-js');
  var tAdded=page.getAttribute('data-t-added');

  /* ---------- Lägg i varukorgen + flygande bild (kunden stannar kvar på sidan) ---------- */
  function money(c){try{return theme.Currency.formatMoney(c,theme.settings.moneyFormat);}catch(e){return Math.round(c/100)+' kr';}}
  function fly(card,done){
    var media=card&&card.querySelector('.cc-card__media');
    var img=media&&media.querySelector('img');
    if(typeof window.claudeShowHeader==='function')window.claudeShowHeader();
    var target=null;
    document.querySelectorAll('.site-header .js-drawer-open-cart').forEach(function(t){var r=t.getBoundingClientRect();if(!target&&r.width>0&&r.height>0)target=t;});
    if(!media||!img||!target||!document.body.animate||window.matchMedia('(prefers-reduced-motion: reduce)').matches){done();return;}
    var a=media.getBoundingClientRect(),b=target.getBoundingClientRect();
    var f=document.createElement('div');f.className='cc-fly';
    f.style.left=a.left+'px';f.style.top=a.top+'px';f.style.width=a.width+'px';f.style.height=a.height+'px';
    var c=document.createElement('img');c.src=img.currentSrc||img.src;c.alt='';f.appendChild(c);document.body.appendChild(f);
    var dx=(b.left+b.width/2)-(a.left+a.width/2),dy=(b.top+b.height/2)-(a.top+a.height/2);
    var sc=Math.max(.08,28/a.width);
    var anim=f.animate([
      {transform:'translate(0,0) scale(1)',opacity:1,borderRadius:'16px'},
      {transform:'translate('+dx*.45+'px,'+(dy*.45-60)+'px) scale(.5)',opacity:1,borderRadius:'40%',offset:.45},
      {transform:'translate('+dx+'px,'+dy+'px) scale('+sc+')',opacity:.35,borderRadius:'50%'}
    ],{duration:800,easing:'cubic-bezier(.45,0,.25,1)',fill:'forwards'});
    anim.onfinish=function(){
      f.remove();
      var icon=target.querySelector('.cart-link')||target;
      if(icon.animate)icon.animate([{transform:'scale(1)'},{transform:'scale(1.25)'},{transform:'scale(1)'}],{duration:420,easing:'cubic-bezier(.34,1.56,.64,1)'});
      done();
    };
  }
  page.addEventListener('submit',function(e){
    var form=e.target.closest('[data-cc-add]');if(!form)return;
    e.preventDefault();
    var btn=form.querySelector('button');if(btn.disabled)return;
    var label=btn.textContent;btn.disabled=true;
    var card=form.closest('[data-cc-card]');
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',body:new FormData(form),headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){if(!r.ok)throw r;return r.json();})
      .then(function(){
        btn.classList.add('is-added');btn.textContent=tAdded;
        fly(card,function(){document.dispatchEvent(new CustomEvent('cart:build'));});
        setTimeout(function(){btn.classList.remove('is-added');btn.textContent=label;btn.disabled=false;},1600);
      })
      .catch(function(){btn.disabled=false;});
  });

  /* ---------- Filter: snabbvalen och filterpanelen delar samma val ----------
     Samma grupp = något av valen (t.ex. Mörk eller Mjölk), olika grupper = alla måste stämma (t.ex. Mörk + 1 kg). */
  var I={};try{I=JSON.parse(page.querySelector('[data-cc-i18n]').textContent);}catch(e){}
  var isBrandPage=page.getAttribute('data-is-brand')==='true',isCalle=page.getAttribute('data-callebaut')==='true';
  var active={};
  function cards(){return [].slice.call(page.querySelectorAll('[data-cc-grid] [data-cc-card]'));}
  var meta=typeof WeakMap!=='undefined'?new WeakMap():null;
  function info(c){
    var m=meta&&meta.get(c);if(m)return m;
    var t=((c.querySelector('.cc-card__title')||{}).textContent||'');
    var cm=t.match(/(\d{2,3})(?:[.,]\d+)?\s*%/);
    m={type:' '+(c.getAttribute('data-type')||'')+' ',size:parseFloat(c.getAttribute('data-size')||0)||0,vendor:c.getAttribute('data-vendor')||'',
       price:+(c.getAttribute('data-price')||0),diet:' '+(c.getAttribute('data-diet')||'')+' ',avail:c.getAttribute('data-avail')!=='false',cocoa:cm?+cm[1]:0};
    if(meta)meta.set(c,m);return m;
  }
  var PRICE=[[0,10000],[10000,20000],[20000,30000],[30000,50000],[50000,1e12]],COCOA=[[1,40],[40,60],[60,70],[70,80],[80,101]];
  function inR(x,r){return x>=r[0]&&x<r[1];}
  function idx(n){var a=[];for(var i=0;i<n;i++)a.push(String(i));return a;}
  function sizeLabel(v){var n=parseFloat(v);return n<1?Math.round(n*1000)+' g':String(n).replace('.',',')+' kg';}
  var GROUPS=[
    {k:'type',vals:function(){return ['mork','mjolk','vit','ruby'];},label:function(v){return (I.types||{})[v]||v;},test:function(m,v){return m.type.indexOf(' '+v+' ')>-1;}},
    {k:'cocoa',vals:function(){return idx(5);},label:function(v){return (I.cocoa||[])[+v];},test:function(m,v){return inR(m.cocoa,COCOA[+v]);}},
    {k:'size',off:!isCalle,vals:function(){var o={};cards().forEach(function(c){var z=info(c).size;if(z>0)o[String(z)]=1;});return Object.keys(o).sort(function(a,b){return a-b;});},label:sizeLabel,test:function(m,v){return Math.abs(m.size-parseFloat(v))<1e-4;}},
    {k:'vendor',off:isBrandPage,vals:function(){var o={};cards().forEach(function(c){var x=info(c).vendor;if(x)o[x]=(o[x]||0)+1;});return Object.keys(o).sort(function(a,b){return o[b]-o[a]||a.localeCompare(b);});},label:function(v){return v;},test:function(m,v){return m.vendor===v;}},
    {k:'price',vals:function(){return idx(5);},label:function(v){return (I.price||[])[+v];},test:function(m,v){return inR(m.price,PRICE[+v]);}},
    {k:'diet',vals:function(){return Object.keys(I.diet||{});},label:function(v){return (I.diet||{})[v];},test:function(m,v){return m.diet.indexOf(' '+v+' ')>-1;}},
    {k:'stock',vals:function(){return ['1'];},label:function(){return I.instock;},test:function(m){return m.avail;}}
  ];
  function grp(k){for(var i=0;i<GROUPS.length;i++)if(GROUPS[i].k===k)return GROUPS[i];return null;}
  function norm(k,v){return k==='size'?String(parseFloat(v)):v;}
  function sel(k){return active[k]?Object.keys(active[k]):[];}
  function nActive(){var n=0;for(var k in active)n+=sel(k).length;return n;}
  function hasChips(){return nActive()>0;}
  function toggle(k,v){v=norm(k,v);active[k]=active[k]||{};if(active[k][v])delete active[k][v];else active[k][v]=1;}
  function pass(m,except){
    for(var k in active){if(k===except)continue;var vs=sel(k);if(!vs.length)continue;var g=grp(k);if(!g)continue;
      if(!vs.some(function(v){return g.test(m,v);}))return false;}
    return true;
  }
  var shownCount=0;
  function applyChips(){
    var shown=0;
    cards().forEach(function(c){var ok=pass(info(c));c.hidden=!ok;if(ok)shown++;});
    shownCount=shown;
    var none=page.querySelector('[data-cc-none]');if(none)none.hidden=!(hasChips()&&shown===0&&!loading);
    var cnt=page.querySelector('[data-cc-count]');
    if(cnt){if(!cnt.dataset.orig)cnt.dataset.orig=cnt.textContent;cnt.textContent=hasChips()&&!loading&&!moreEl()?cnt.dataset.orig.replace(/^\s*\d+/,shown):cnt.dataset.orig;}
    var ft=page.querySelector('[data-cc-ftxt]');
    if(ft){var n=nActive()+(+ft.getAttribute('data-server')||0);ft.textContent=ft.getAttribute('data-base')+(n?' ('+n+')':'');ft.parentNode.classList.toggle('is-active',n>0);}
    renderFacets();
  }
  var chipsBox=page.querySelector('[data-cc-chips]');
  var tagsBox=page.querySelector('[data-cc-ctags]');
  function paintChips(){
    if(chipsBox){
      chipsBox.querySelectorAll('button[data-chip]').forEach(function(x){
        var xg=x.getAttribute('data-chip');
        var on=xg==='all'?!hasChips():!!(active[xg]&&active[xg][norm(xg,x.getAttribute('data-val'))]);
        x.classList.toggle('is-active',on);x.setAttribute('aria-pressed',on?'true':'false');
      });
    }
    if(tagsBox){
      var h='';
      GROUPS.forEach(function(g){sel(g.k).forEach(function(v){
        h+='<button type="button" class="cc-tag" data-g="'+g.k+'" data-v="'+esc(v)+'">'+esc(g.label(v))+' <span aria-hidden="true">✕</span></button>';
      });});
      if(h)h+='<button type="button" class="cc-tag cc-tag--reset" data-cc-reset>'+esc(tagsBox.getAttribute('data-t-reset'))+' <span aria-hidden="true">✕</span></button>';
      tagsBox.innerHTML=h;tagsBox.hidden=!h;
    }
    if(typeof syncArrows==='function')syncArrows();
  }
  function changed(){paintChips();applyChips();if(hasChips())loadAll();}
  if(chipsBox){
    var sz=[].slice.call(chipsBox.querySelectorAll('[data-chip="size"]'));
    sz.sort(function(a,b){return parseFloat(a.getAttribute('data-sort'))-parseFloat(b.getAttribute('data-sort'));}).forEach(function(b){chipsBox.appendChild(b);});
    chipsBox.addEventListener('click',function(e){
      var b=e.target.closest('button[data-chip]');if(!b)return;
      var g=b.getAttribute('data-chip');
      if(g==='all')active={};else toggle(g,b.getAttribute('data-val'));
      changed();
    });
  }
  if(tagsBox){
    tagsBox.addEventListener('click',function(e){
      var t=e.target.closest('button');if(!t)return;
      if(t.hasAttribute('data-cc-reset'))active={};
      else{var g=t.getAttribute('data-g');if(active[g])delete active[g][t.getAttribute('data-v')];}
      changed();
    });
  }

  /* ---------- Filterpanelen ---------- */
  var sheet=page.querySelector('[data-cc-sheet]'),facets=sheet&&sheet.querySelector('[data-cc-facets]'),sheetOpen=false,vendorAll=false,lastFocus=null;
  if(sheet){
    sheet.querySelector('[data-cc-sheet-title]').textContent=I.title||'Filter';
    sheet.querySelector('[data-cc-close-label]').setAttribute('aria-label',I.close||'');
    sheet.querySelector('[data-cc-clear]').textContent=I.clear||'';
    document.body.appendChild(sheet);
  }
  function renderFacets(){
    if(!sheetOpen||!facets)return;
    var top=facets.scrollTop,cs=cards().map(info),h='';
    GROUPS.forEach(function(g){
      if(g.off)return;
      if(g.k==='stock'&&!cs.some(function(m){return !m.avail;}))return;
      var items=g.vals().map(function(v){
        var n=0;cs.forEach(function(m){if(g.test(m,v)&&pass(m,g.k))n++;});
        var any=cs.some(function(m){return g.test(m,v);});
        return {v:v,n:n,any:any,on:!!(active[g.k]&&active[g.k][v])};
      }).filter(function(x){return x.any||x.on;});
      if(items.length<(g.k==='stock'?1:2))return;
      var lim=g.k==='vendor'&&!vendorAll&&items.length>10?8:items.length;
      h+='<section class="cc-facet"><h3 class="cc-facet__title">'+esc((I.g||{})[g.k]||g.k)+'</h3><div class="cc-facet__opts">';
      items.forEach(function(x,i){
        if(i>=lim&&!x.on)return;
        h+='<button type="button" class="cc-chip cc-fpill'+(x.on?' is-active':'')+'" data-fg="'+g.k+'" data-fv="'+esc(x.v)+'" aria-pressed="'+(x.on?'true':'false')+'"'+(!x.n&&!x.on?' disabled':'')+'>'+esc(g.label(x.v))+' <span class="cc-fpill__n">'+x.n+'</span></button>';
      });
      if(lim<items.length)h+='<button type="button" class="cc-facet__more" data-cc-vall>'+esc(I.more||'')+' ('+items.length+')</button>';
      h+='</div></section>';
    });
    facets.innerHTML=h;facets.scrollTop=top;
    var ap=sheet.querySelector('[data-cc-apply]');
    ap.textContent=loading||moreEl()?(I.loading||''):(shownCount===1?I.show1:(shownCount?(I.show||'').replace('{n}',shownCount):I.none));
    sheet.querySelector('[data-cc-clear]').disabled=!hasChips();
  }
  function openSheet(){
    if(!sheet)return;lastFocus=document.activeElement;
    sheet.hidden=false;sheetOpen=true;document.documentElement.classList.add('cc-lock');
    renderFacets();if(moreEl())loadAll();
    requestAnimationFrame(function(){requestAnimationFrame(function(){sheet.classList.add('is-open');sheet.querySelector('.cc-sheet__panel').focus();});});
  }
  function closeSheet(){
    if(!sheetOpen)return;sheetOpen=false;sheet.classList.remove('is-open');document.documentElement.classList.remove('cc-lock');
    setTimeout(function(){if(!sheetOpen)sheet.hidden=true;},300);
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  page.addEventListener('click',function(e){if(e.target.closest('[data-cc-open-filter]')){e.preventDefault();openSheet();}});
  if(sheet){
    sheet.addEventListener('click',function(e){
      var p=e.target.closest('[data-fg]');
      if(p){toggle(p.getAttribute('data-fg'),p.getAttribute('data-fv'));changed();return;}
      if(e.target.closest('[data-cc-vall]')){vendorAll=true;renderFacets();return;}
      if(e.target.closest('[data-cc-clear]')){active={};changed();return;}
      if(e.target.closest('[data-cc-close]')){closeSheet();var g=page.querySelector('[data-cc-grid]');if(g&&e.target.closest('[data-cc-apply]')){var y=g.getBoundingClientRect().top+window.pageYOffset-140;if(window.pageYOffset>y)window.scrollTo(0,y);}}
    });
    document.addEventListener('keydown',function(e){if(sheetOpen&&e.key==='Escape')closeSheet();});
  }

  /* ---------- Snabbval på mobil: pilar + tonad kant när fler val finns åt sidan ---------- */
  var chipBar=page.querySelector('[data-cc-chipbar]');
  if(chipBar&&chipsBox){
    var prevB=chipBar.querySelector('[data-cc-scroll="-1"]'),nextB=chipBar.querySelector('[data-cc-scroll="1"]');
    var syncArrows=function(){
      var max=chipsBox.scrollWidth-chipsBox.clientWidth;
      var canPrev=chipsBox.scrollLeft>4,canNext=chipsBox.scrollLeft<max-4;
      chipBar.classList.toggle('can-prev',canPrev);chipBar.classList.toggle('can-next',canNext);
      prevB.hidden=!canPrev;nextB.hidden=!canNext;
    };
    chipBar.addEventListener('click',function(e){
      var a=e.target.closest('[data-cc-scroll]');if(!a)return;
      chipsBox.scrollBy({left:(+a.getAttribute('data-cc-scroll'))*chipsBox.clientWidth*0.7,behavior:'smooth'});
    });
    chipsBox.addEventListener('scroll',function(){window.requestAnimationFrame(syncArrows);},{passive:true});
    window.addEventListener('resize',syncArrows);
    syncArrows();
  }

  /* ---------- Fler produkter när man scrollar ---------- */
  var loading=false,io=null;
  function moreEl(){return page.querySelector('[data-cc-more]');}
  function loadNext(){
    var m=moreEl();if(!m||loading)return Promise.resolve(false);
    var url=m.getAttribute('data-next');if(!url)return Promise.resolve(false);
    loading=true;m.classList.add('is-loading');
    var sid=page.getAttribute('data-section-id');
    var u=url+(url.indexOf('?')>-1?'&':'?')+'section_id='+encodeURIComponent(sid);
    return fetch(u,{credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var grid=page.querySelector('[data-cc-grid]');
      doc.querySelectorAll('[data-cc-grid] [data-cc-card]').forEach(function(c){grid.appendChild(document.importNode(c,true));});
      var nm=doc.querySelector('[data-cc-more]');
      if(nm){m.setAttribute('data-next',nm.getAttribute('data-next'));m.querySelector('a').href=nm.getAttribute('data-next');m.classList.remove('is-loading');}
      else{m.remove();}
      loading=false;applyChips();
      return !!nm;
    }).catch(function(){loading=false;m.classList.remove('is-loading');return false;});
  }
  /* Alla produkter på en gång (filterpanelen behöver alla för att räkna och filtrera):
     hämtas parallellt i block om 100 via ?view=claude-cards i stället för sida för sida,
     och förhämtas i bakgrunden när sidan är klar så att filtret känns direkt. */
  var TOTAL=(function(){var c=page.querySelector('[data-cc-count]');return c?parseInt((c.textContent||'').replace(/\D/g,''),10)||0:0;})();
  var fastP=null,fastKey='',allBusy=false;
  function fastUrl(p){
    var q=location.search.replace(/^\?/,'').split('&').filter(function(x){return x&&!/^(view|page|section_id)=/.test(x);});
    q.push('view=claude-cards','page='+p);
    return location.pathname+'?'+q.join('&');
  }
  function getCards(p){
    return fetch(fastUrl(p),{credentials:'same-origin'}).then(function(r){if(!r.ok)throw r;return r.text();}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      return {cards:[].slice.call(doc.querySelectorAll('[data-cc-card]')),next:!!doc.querySelector('[data-cc-next]')};
    });
  }
  function fetchAllCards(){
    if(location.pathname.indexOf('/collections/')<0)return Promise.resolve(null);
    if(fastP&&fastKey===location.search)return fastP;
    fastKey=location.search;
    var pages=TOTAL>0?Math.min(20,Math.ceil(TOTAL/100)):1,reqs=[];
    for(var i=1;i<=pages;i++)reqs.push(getCards(i));
    fastP=Promise.all(reqs).then(function(res){
      var list=[];res.forEach(function(r){list=list.concat(r.cards);});
      if(!list.length)throw 0;
      /* Fler än väntat (t.ex. nya produkter): hämta resten en i taget */
      var p=pages;
      function rest(last){if(!last.next||p>=30)return list;p++;return getCards(p).then(function(r){list=list.concat(r.cards);return rest(r);});}
      return rest(res[res.length-1]);
    }).catch(function(){fastP=null;return null;});
    return fastP;
  }
  function slowAll(){loadNext().then(function(more){if(more)slowAll();else applyChips();});}
  function loadAll(){
    var m=moreEl();if(!m){applyChips();return;}
    if(allBusy)return;allBusy=true;loading=true;m.classList.add('is-loading');renderFacets();
    fetchAllCards().then(function(list){
      allBusy=false;loading=false;
      if(!list){m.classList.remove('is-loading');slowAll();return;}
      var grid=page.querySelector('[data-cc-grid]'),have={};
      cards().forEach(function(c){have[c.getAttribute('data-pid')]=1;});
      var frag=document.createDocumentFragment();
      list.forEach(function(c){var id=c.getAttribute('data-pid');if(!id||have[id])return;have[id]=1;frag.appendChild(document.importNode(c,true));});
      grid.appendChild(frag);
      if(m.parentNode)m.remove();
      if(io){io.disconnect();io=null;}
      applyChips();
    });
  }
  /* Förhämta i bakgrunden när sidan har laddat klart (bara texten – bilderna laddas först när de syns) */
  if(moreEl()){
    var pre=function(){fetchAllCards();};
    window.addEventListener('load',function(){setTimeout(function(){(window.requestIdleCallback||function(f){setTimeout(f,1)})(pre);},1500);});
    page.addEventListener('pointerdown',function(e){if(e.target.closest('[data-cc-open-filter],[data-chip]'))pre();},true);
  }
  function setupScroll(){
    if(io){io.disconnect();io=null;}
    var m=moreEl();if(!m)return;
    if('IntersectionObserver' in window){
      io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting)loadNext();});},{rootMargin:'800px 0px'});
      io.observe(m);
    }
  }
  setupScroll();
  /* Temat byter ut produktlistan när man filtrerar/sorterar – starta om scroll och snabbval */
  var res=document.getElementById('CollectionAjaxResult');
  if(res&&window.MutationObserver){new MutationObserver(function(){setupScroll();applyChips();if(hasChips())loadAll();}).observe(res,{childList:true});}

  /* ---------- Fast filterrad på mobil: hamnar under sidhuvudet när det visas ---------- */
  var bar=page.querySelector('[data-cc-bar]');
  var header=document.querySelector('.header-wrapper .site-header');
  function syncTop(){
    if(!bar||!header)return;
    var top=0;
    if(header.classList.contains('claude-fixed')&&!header.classList.contains('claude-hidden')){var r=header.getBoundingClientRect();top=Math.max(0,r.bottom+6);}
    bar.style.setProperty('--cc-sticky-top',top+'px');
  }
  if(header&&window.MutationObserver){new MutationObserver(syncTop).observe(header,{attributes:true,attributeFilter:['class']});}
  window.addEventListener('scroll',function(){window.requestAnimationFrame(syncTop);},{passive:true});
  syncTop();

  /* ---------- Gemensam kortmall (för "Passar bra till") ---------- */
  function esc(s){var d=document.createElement('div');d.textContent=s==null?'':s;return d.innerHTML;}
  function imgUrl(u,w){if(!u)return '';u=u.indexOf('//')===0?'https:'+u:u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;}
  function kgOf(title){
    var t=(title||'').toLowerCase().replace(/,/g,'.');var m,kg=0,re=/(\d+(?:\.\d+)?)\s*(kg|g)\b/g;
    while((m=re.exec(t))){kg=m[2]==='kg'?parseFloat(m[1]):parseFloat(m[1])/1000;}
    return kg;
  }
  function cardHtml(p){
    var v=null;for(var i=0;i<p.variants.length;i++){if(p.variants[i].available){v=p.variants[i];break;}}
    if(!v)return '';
    var c=v.compare_at_price||0,pct=c>v.price?Math.floor((c-v.price)*100/c):0;
    var price=pct?'<s class="cc-card__was">'+money(c)+'</s><span class="cc-card__now cc-card__now--sale">'+money(v.price)+'</span>':'<span class="cc-card__now">'+money(v.price)+'</span>';
    var ppk='';
    if(/callebaut/i.test(p.vendor||'')){var kg=kgOf(p.title);if(kg>0)ppk='<span class="cc-card__ppk">'+money(Math.round(v.price/kg/100)*100).replace(/[,.]00(?=\D*$)/,'')+'/kg</span>';}
    var src=p.featured_image||(p.images&&p.images[0]);
    var buy=page.getAttribute('data-t-buy');
    return '<div class="cc-card" data-cc-card><a class="cc-card__media" href="'+p.url+'" tabindex="-1" aria-hidden="true">'+(src?'<img class="cc-card__img" src="'+imgUrl(src,500)+'" alt="'+esc(p.title)+'" loading="lazy">':'')+(pct?'<span class="cc-card__badge">&minus;'+pct+'%</span>':'')+'</a>'+
      '<div class="cc-card__info"><a class="cc-card__title" href="'+p.url+'">'+esc(p.title)+'</a>'+
      '<div class="cc-card__price">'+price+ppk+'</div>'+
      '<form action="/cart/add" method="post" class="cc-card__form" data-cc-add><input type="hidden" name="id" value="'+v.id+'"><input type="hidden" name="quantity" value="1"><button type="submit" class="cc-card__btn">'+buy+'</button></form></div></div>';
  }

  /* ---------- Passar bra till (verkliga köp, samma data som varukorgen) ---------- */
  var recs=page.querySelector('[data-cc-recs]');
  var TOOLS=/(form|spatel|verktyg|termometer|pensel|sprits|tillbehor|skrapa|gjutform)/;
  function initRecs(){
    if(!recs||recs.dataset.done)return;recs.dataset.done='1';
    var ids=(recs.getAttribute('data-ids')||'').split(',').filter(Boolean).map(Number);
    /* Utesluter bara det kunden redan ser (produkterna på sidan), inte hela kategorin */
    var onPage={};cards().forEach(function(c){var id=+c.getAttribute('data-pid');if(id)onPage[id]=1;});
    var isBrand=page.getAttribute('data-is-brand')==='true',brand=(page.getAttribute('data-brand')||'').toLowerCase();
    fetch(recs.getAttribute('data-src')).then(function(r){return r.json();}).then(function(d){
      var byId={};d.p.forEach(function(p,i){byId[p[0]]=i;});
      var score={};
      ids.forEach(function(id,pos){
        var i=byId[id];if(i===undefined)return;
        var w=Math.max(0.15,1-pos/16);
        (d.r[i]||[]).forEach(function(idx,rank){
          var p=d.p[idx];if(!p||onPage[p[0]]||/^gift-wrap$/.test(p[1]))return;
          score[p[1]]=(score[p[1]]||0)+(8-rank)*w;
        });
      });
      var all=Object.keys(score).sort(function(a,b){return score[b]-score[a];});
      var handles=all.slice(0,14);
      /* På varumärkessidor: 2 tillbehör (formar, verktyg) som köpts tillsammans med märket */
      if(isBrand){all.filter(function(h){return h.indexOf(brand.split(' ')[0])<0&&TOOLS.test(h);}).slice(0,2).forEach(function(h){if(handles.indexOf(h)<0)handles.push(h);});}
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      return Promise.all(handles.map(function(h){return fetch(root+'products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});}));
    }).then(function(ps){
      if(!ps)return;
      ps=ps.filter(function(p){return p&&p.available&&!onPage[p.id];});
      /* Bästa 6 oavsett märke + 2 tillbehör från andra märken (på varumärkessidor) */
      var tools=isBrand?ps.filter(function(p){return (p.vendor||'').toLowerCase()!==brand&&TOOLS.test(p.handle);}).slice(0,2):[];
      var out=ps.filter(function(p){return tools.indexOf(p)<0;}).slice(0,8-tools.length).concat(tools);
      if(out.length<2)return fallbackRecs();
      recs.querySelector('[data-cc-recs-track]').innerHTML=out.map(cardHtml).join('');
      recs.hidden=false;
    }).catch(function(){fallbackRecs();});
  }
  /* Produktsidan: finns inga köp-tillsammans-data används Shopifys egna rekommendationer */
  function fallbackRecs(){
    var pid=recs&&recs.getAttribute('data-pid');if(!pid)return;
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'recommendations/products.json?product_id='+pid+'&limit=8').then(function(r){return r.json();}).then(function(d){
      var ps=((d&&d.products)||[]).filter(function(p){return p.available&&String(p.id)!==String(pid);});
      if(ps.length<2)return;
      recs.querySelector('[data-cc-recs-track]').innerHTML=ps.map(cardHtml).join('');
      recs.hidden=false;
    }).catch(function(){});
  }

  /* ---------- Recensioner för just dessa produkter (Judge.me) ---------- */
  var rv=page.querySelector('[data-cc-reviews]');
  var ANON=/^(anonym|anonymous|anonymt|anon|ukendt|okänd)\b/i;
  var COLORS=['#7a4a2e','#9c7f4f','#5a6b4f','#8b3a3a','#4f5f7a','#a0673a','#3f5a52'];
  function starsEl(n){var s='<span class="claude-reviews__stars" role="img" aria-label="'+n+' / 5">';for(var i=1;i<=5;i++)s+='<span class="claude-reviews__star'+(i<=n?' is-on':'')+'" aria-hidden="true">★</span>';return s+'</span>';}
  function revCard(r,i){
    var d='';try{d=new Date(r.date).toLocaleDateString(rv.getAttribute('data-locale')==='da'?'da-DK':'sv-SE',{day:'numeric',month:'short',year:'numeric'});}catch(e){}
    return '<article class="claude-reviews__card"><div class="claude-reviews__head"><span class="claude-reviews__avatar" aria-hidden="true" style="background:'+COLORS[i%COLORS.length]+'">'+esc(r.name.charAt(0).toUpperCase())+'</span><div class="claude-reviews__who"><div class="claude-reviews__name-line"><span class="claude-reviews__name">'+esc(r.name)+'</span>'+starsEl(r.rating)+'</div>'+
      (r.verified?'<span class="claude-reviews__verified"><svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" class="claude-reviews__verified-icon"><circle cx="8" cy="8" r="8"></circle><path d="M4.6 8.3l2.2 2.2 4.6-4.8" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg><span>'+esc(rv.getAttribute('data-t-verified'))+'</span></span>':'')+'</div></div>'+
      (r.title?'<p class="claude-reviews__review-title">'+esc(r.title)+'</p>':'')+(r.body?'<p class="claude-reviews__body">'+esc(r.body)+'</p>':'')+
      '<div class="claude-reviews__foot"><a class="claude-reviews__product" href="'+esc(r.url)+'">'+esc(r.product)+'</a><span class="claude-reviews__date">'+esc(d)+'</span></div></article>';
  }
  function initReviews(){
    if(!rv||rv.dataset.done)return;rv.dataset.done='1';
    var list=(rv.getAttribute('data-products')||'').split(',').filter(Boolean).map(function(x){var a=x.split(':');return {id:a[0],c:+a[1]};});
    list.sort(function(a,b){return b.c-a.c;});list=list.slice(0,6);
    var shop=rv.getAttribute('data-shop');
    Promise.all(list.map(function(p){
      var u='https://api.judge.me/reviews/reviews_for_widget?url='+shop+'&shop_domain='+shop+'&platform=shopify&page=1&per_page=6&product_id='+p.id;
      return fetch(u).then(function(r){return r.json();}).then(function(j){return j.html||'';}).catch(function(){return '';});
    })).then(function(htmls){
      var tmp=document.createElement('div');tmp.innerHTML=htmls.join('');
      var out=[],names={};
      tmp.querySelectorAll('.jdgm-rev').forEach(function(el){
        var name=((el.querySelector('.jdgm-rev__author')||{}).textContent||'').trim();
        var rating=parseInt((el.querySelector('[data-score]')||{getAttribute:function(){return 0;}}).getAttribute('data-score'),10)||0;
        var body=((el.querySelector('.jdgm-rev__body')||{}).textContent||'').replace(/\s+/g,' ').trim();
        var title=((el.querySelector('.jdgm-rev__title')||{}).textContent||'').trim();
        if(!name||ANON.test(name)||rating<4||(title+body).length<12)return;
        var k=name.toLowerCase();if(names[k])return;names[k]=1;
        var t=el.querySelector('.jdgm-rev__timestamp');
        out.push({name:name,rating:rating,body:body,title:title===body?'':title,verified:el.getAttribute('data-verified-buyer')==='true',date:t?t.getAttribute('datetime'):'',product:el.getAttribute('data-product-title')||'',url:el.getAttribute('data-product-url')||''});
      });
      out.sort(function(a,b){return (b.rating-a.rating)||((b.title+b.body).length-(a.title+a.body).length);});
      out=out.slice(0,12);
      if(!out.length)return;
      buildCarousel(out);
    });
  }
  function buildCarousel(list){
    var track=rv.querySelector('[data-track]'),viewport=rv.querySelector('[data-viewport]');
    var n=list.length;
    track.innerHTML=list.map(revCard).join('');
    for(var k=0;k<Math.min(3,n);k++){var cl=track.children[k].cloneNode(true);cl.setAttribute('aria-hidden','true');cl.querySelectorAll('a').forEach(function(a){a.setAttribute('tabindex','-1');});track.appendChild(cl);}
    rv.querySelector('[data-stage]').hidden=false;rv.querySelector('[data-controls]').hidden=false;
    var index=0,paused=false,timer=null,resetT=null;
    function pv(){var w=window.innerWidth;return w>=990?3:(w>=590?2:1);}
    function step(){var f=track.children[0];var g=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap)||0;return f.getBoundingClientRect().width+g;}
    function layout(){rv.style.setProperty('--claude-per-view',pv());rv.classList.toggle('is-static',n<=pv());}
    function go(i,anim){track.style.transition=anim===false?'none':'';index=i;track.style.transform='translateX('+(-index*step())+'px)';}
    function next(){if(n<=pv())return;clearTimeout(resetT);if(index>=n){go(0,false);track.getBoundingClientRect();}go(index+1);if(index>=n)resetT=setTimeout(function(){go(0,false);},520);}
    function prev(){if(n<=pv())return;clearTimeout(resetT);if(index<=0){go(n,false);track.getBoundingClientRect();}go(index-1);}
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    function start(){stop();if(!paused)timer=setInterval(next,4000);}
    var pb=rv.querySelector('[data-pause]'),pl=rv.querySelector('[data-pause-label]');
    pb.addEventListener('click',function(){paused=!paused;pb.setAttribute('aria-pressed',paused?'true':'false');pb.classList.toggle('is-paused',paused);pl.textContent=paused?rv.getAttribute('data-t-play'):rv.getAttribute('data-t-pause');start();});
    rv.querySelector('[data-next]').addEventListener('click',function(){next();start();});
    rv.querySelector('[data-prev]').addEventListener('click',function(){prev();start();});
    var x0=null,y0=null;
    viewport.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});
    viewport.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;x0=y0=null;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){(dx<0?next:prev)();start();}},{passive:true});
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else start();});
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){layout();go(index>=n?0:index,false);},150);});
    layout();go(0,false);start();
  }

  /* Recensioner och rekommendationer laddas först när kunden närmar sig dem */
  function lazy(el,fn){if(!el)return;if(!('IntersectionObserver' in window)){fn();return;}var o=new IntersectionObserver(function(en){if(en.some(function(x){return x.isIntersecting;})){o.disconnect();fn();}},{rootMargin:'600px 0px'});o.observe(el);}
  lazy(rv,initReviews);
  lazy(page.querySelector('.cc-trust')||page.querySelector('[data-cc-recs-anchor]'),initRecs);
})();
